/**
 * Operations routes: each area contributes its own list.
 *
 * What is left is what distribution needs — the godowns goods sit in and move
 * between, and the dispatch that takes an order out of them. Making, buying,
 * packing and checking goods were a factory's concerns and are no longer part
 * of this product.
 */
import type { ReactElement } from 'react';
import { warehouseRoutes } from './warehouse/routes';
import { dispatchRoutes } from './dispatch/routes';

export function operationsRoutes(): ReactElement[] {
  return [
    ...warehouseRoutes(),
    ...dispatchRoutes(),
  ];
}
